import Chart from './Chart';
import SmartChart from './SmartChart';

export default Chart;
export { SmartChart };
